<template>
  <div id="footer">
    <div class="common-container flex justify-center al">
      <div class="logo" @click="linkWdit">
        <img src="@/assets/images/footer-logo.png" alt />
      </div>
      <ul class="call">
        <li>电话热线：021-50801950<b></b> 联系传真：021-38953445</li>
        <li>联系地址：上海市浦东新区盛荣路88弄3号楼11层</li>
        <li>CopyRight © 2021 融媒开放平台 版权所有</li>
      </ul>
      <div class="code">
        <img src="@/assets/images/footer-code.png" alt="">
      </div> 
    </div>
  </div>
</template>
<script setup>
const linkWdit =()=>{
  window.location.href = 'https://www.wdit.com.cn/'
}
</script>
<style lang="less" >
#footer {
  padding: 42px 0;
  background: #373c52;
  .logo{
    width: 200px;
  }
  .call{
    margin:0 60px;
    color:#fff;
    li{
      padding-bottom:10px;
    }
  }
  .code{
    width:180px;
  }
}

#footer p {
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 2;
}
</style>